import type { AchievementDef, PlayerAchievementStats } from './types';

const sport = 'football' as const;
const ruName = 'Футбол';
const enName = 'Football';
const color = '#22C55E';
const iconKey = 'football';

const games = (s: PlayerAchievementStats) => s.perSport[sport]?.games ?? 0;
const wins  = (s: PlayerAchievementStats) => s.perSport[sport]?.wins ?? 0;
const mvp   = (s: PlayerAchievementStats) => s.perSport[sport]?.mvp ?? 0;
const elo   = (s: PlayerAchievementStats) => s.perSport[sport]?.eloMax ?? 0;

export const footballAchievements: AchievementDef[] = [
  {
    key: `${sport}.first_game`,
    sport,
    category: 'activity',
    name: { ru: `Первая игра — ${ruName}`, en: `First ${enName} game` },
    description: { ru: '1 завершённая игра', en: '1 finished game' },
    icon: iconKey,
    color,
    check: (s) => games(s) >= 1,
    progress: (s) => ({ current: Math.min(games(s), 1), target: 1 }),
  },
  {
    key: `${sport}.ten_games`,
    sport,
    category: 'activity',
    name: { ru: `${ruName}: 10 игр`, en: `${enName}: 10 games` },
    description: { ru: '10 завершённых игр', en: '10 finished games' },
    icon: iconKey,
    color,
    check: (s) => games(s) >= 10,
    progress: (s) => ({ current: Math.min(games(s), 10), target: 10 }),
  },
  {
    key: `${sport}.fifty_games`,
    sport,
    category: 'activity',
    name: { ru: `${ruName}: 50 игр`, en: `${enName}: 50 games` },
    description: { ru: '50 завершённых игр', en: '50 finished games' },
    icon: iconKey,
    color,
    check: (s) => games(s) >= 50,
    progress: (s) => ({ current: Math.min(games(s), 50), target: 50 }),
  },
  {
    key: `${sport}.first_win`,
    sport,
    category: 'wins',
    name: { ru: `${ruName}: первая победа`, en: `${enName}: first win` },
    description: { ru: '1 победа', en: '1 win' },
    icon: 'trophy',
    color,
    check: (s) => wins(s) >= 1,
    progress: (s) => ({ current: Math.min(wins(s), 1), target: 1 }),
  },
  {
    key: `${sport}.ten_wins`,
    sport,
    category: 'wins',
    name: { ru: `${ruName}: 10 побед`, en: `${enName}: 10 wins` },
    description: { ru: '10 побед', en: '10 wins' },
    icon: 'trophy',
    color,
    check: (s) => wins(s) >= 10,
    progress: (s) => ({ current: Math.min(wins(s), 10), target: 10 }),
  },
  {
    key: `${sport}.first_mvp`,
    sport,
    category: 'mvp',
    name: { ru: `${ruName}: MVP`, en: `${enName}: MVP` },
    description: { ru: 'Первый MVP', en: 'First MVP' },
    icon: 'crown',
    color,
    check: (s) => mvp(s) >= 1,
    progress: (s) => ({ current: Math.min(mvp(s), 1), target: 1 }),
  },
  {
    key: `${sport}.elo_2200`,
    sport,
    category: 'rating',
    name: { ru: `${ruName}: рейтинг 2200`, en: `${enName}: ELO 2200` },
    description: { ru: 'ELO ≥ 2200', en: 'ELO ≥ 2200' },
    icon: 'star',
    color,
    check: (s) => elo(s) >= 2200,
    progress: (s) => ({ current: Math.min(elo(s), 2200), target: 2200 }),
  },
];
